import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import { Link } from 'react-router-dom';

export const Banner = styled.div`
  background-color: ${(props) => props.theme.color.blue.lightBlue};
  color: ${(props) => props.theme.color.blue.default};
  font-size: 16px;
  padding: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BannerIcon = styled.img`
  height: 30px;
  width: 30px;
  margin-right: 12px;
`;

export const TopWrapper = styled.div`
  padding-top: 50px;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Column = styled.div`
  padding-right: 30px;
  /* width: 25%; */
  width: 33%;
  margin-bottom: 50px;
  ${mediaQuery('tablet')} {
    margin-bottom: 30px;
    text-align: center;
    width: 50%;
  }
  ${mediaQuery('small')} {
    text-align: center;
    width: 100%;
  }
`;

export const ColumnTitle = styled.div`
  color: ${(props) => props.theme.color.blue.default};
  font-weight: 700;
  margin-bottom: 12px;
`;

export const ColumnLink = styled(Link)<{ clickable?: string }>`
  color: ${(props) => props.theme.color.dark.default};
  display: block;
  font-weight: 500;
  padding: 8px 0;
  position: relative;

  ${(props) =>
    props.clickable === 'true' &&
    `
  cursor: pointer;
  &:hover {
    color: ${props.theme.color.blue.default};
  }
  `}
`;

export const ColumnChildren = styled.div`
  margin-top: 8px;
`;

export const RowLink = styled(ColumnLink)`
  ${mediaQuery('small')} {
    width: 100%;
    text-align: center;
  }

  &:not(:last-of-type) {
    &::after {
      ${mediaQuery('tablet', 'min')} {
        content: '•';
        margin-right: 20px;
        margin-left: 20px;
      }
    }
  }
`;

export const BottomWrapper = styled.div`
  border-top: 1px solid ${(props) => props.theme.color.light.shade};
  padding: 50px 0;
`;

export const Row = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaQuery('tablet')} {
    & > *:not(:last-child) {
      margin-right: 20px;
    }
    margin-bottom: 30px;
  }
  ${mediaQuery('small')} {
    & > *:not(:last-child) {
      margin-right: 0;
    }
    margin-bottom: 30px;
  }
  flex-wrap: wrap;
`;

export const InternalLinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  font-size: 16px;
  padding: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
